import React from "react";

const MainContainer: React.FC<ParentLayoutProps> = ({ children }) => {
  return <div className="flex flex-col w-full ">{children}</div>;
};

export default MainContainer;
